import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

export class UnitsTrainSilver10000Handler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.UNITS_TRAIN_SILVER_10000);
    }
}
